import { gql } from '@apollo/client';
import { CLAIM_FIELDS } from '@/graphql/fragments/claims';
import { ORDER_FIELDS } from '@/graphql/queries/orders';
import { CLIENT_FIELDS } from '@/graphql/queries/clients';
import { NOTE_FIELDS } from '@/graphql/queries/notes';
import { ITEM_FIELDS } from '@/graphql/queries/items';

export const GET_CLAIM = gql`
    ${CLAIM_FIELDS}
    ${ORDER_FIELDS}
    ${ITEM_FIELDS}
    ${CLIENT_FIELDS}
    ${NOTE_FIELDS}
    query GetClaim($claim_id: uuid!) {
        claims(where: { claim_id: { _eq: $claim_id } }) {
            ...ClaimFields
            order {
                ...OrderFields
                itemsByOrderId {
                    ...ItemFields
                }
                order_carrier {
                    ...ClientFields
                }
                order_middle_mile_carrier {
                    ...ClientFields
                }
                order_shipper {
                    ...ClientFields
                }
            }
            notes {
                ...NoteFields
            }
            shipper {
                ...ClientFields
            }
            carrier {
                ...ClientFields
            }
            middle_mile_carrier {
                ...ClientFields
            }
        }
    }
`;

export const UPDATE_CLAIM = gql`
    ${CLAIM_FIELDS}
    mutation UpdateClaim($claim_id: uuid!, $update: claims_set_input!) {
        update_claims(where: { claim_id: { _eq: $claim_id } }, _set: $update) {
            returning {
                ...ClaimFields
            }
        }
    }
`;

/** The claim order's clones, such as its return order, never its split children. */
export const GET_RETURN_ORDERS = gql`
    ${ORDER_FIELDS}
    query GetClaimReturnOrder($original_order_id: uuid!) {
        orders(where: { original_order_id: { _eq: $original_order_id }, split_seq: { _is_null: true } }) {
            ...OrderFields
        }
    }
`;
